export default __webpack_public_path__ + "static/media/contact.4343e8b7.svg";